// the google-maps-react type definitions have a syntax error, causing Typescript
// to fail to compile.
// We must reexport it here with corrected types until they get around to
// fixing it.

module.exports = require('google-maps-react')
